// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7a0545fc","453":"f4c09c2a","455":"331703d4","977":"35fc5158"}[chunkId] + ".chunk.js";
};